import MediaPlayer_videoBoxResponsiveComponent from '@wix/thunderbolt-elements/src/components/VideoBoxContainer/VideoBox/viewer/skinComps/VideoBoxResponsive/videoBoxResponsive.skin';
import MediaPlayer_videoBoxResponsiveController from '@wix/thunderbolt-elements/src/components/VideoBoxContainer/VideoBox/viewer/VideoBox.controller';


const MediaPlayer_videoBoxResponsive = {
  component: MediaPlayer_videoBoxResponsiveComponent,
  controller: MediaPlayer_videoBoxResponsiveController
};


export const components = {
  ['MediaPlayer_videoBoxResponsive']: MediaPlayer_videoBoxResponsive
};

